import React from "react";
import { Modal, ModalBody } from "reactstrap";
import "./Preview.css";
import { ImageLink } from "../../../utils/constants";
import { Link } from "react-router-dom";

const Preview = ({ form, onClose, isOpen, position = "center" }) => {
  const getStyle = (field) => {
    return {
      textAlign: (field || "left").toLowerCase().trim(),
      display: "block",
    };
  };

  const positionClass =
    {
      center: "modal-dialog-centered",
      "top-left": "custom-top-left",
      "top-right": "custom-top-right",
      "bottom-left": "custom-bottom-left",
      "bottom-right": "custom-bottom-right",
    }[position] || "modal-dialog-centered";

  return (
    <Modal isOpen={isOpen} toggle={onClose} modalClassName={positionClass}>
      {form?.type === "newsletter" ? (
     <ModalBody
  style={{
    width: "500px",
    padding: 0,
    backgroundColor: "#fff",
    display: "flex",
    flexDirection: "column",
    textAlign: "center",
    overflow: "hidden",
  }}
>
  {form?.image && (
    <div style={{ width: "100%", height: "300px" }}>
      <img
        src={ImageLink(form.image)}
        alt="Newsletter Banner"
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
        }}
      />
    </div>
  )}

  <div style={{ padding: "30px" }}>
    <h1 style={getStyle(form?.headingStyle)}>{form?.heading}</h1>
    <p>{form?.description}</p>
    <form
      onSubmit={(e) => {
        e.preventDefault();
        alert("Subscribed!");
      }}
    >
      <input
        type="email"
        placeholder="Enter your email"
        required
        style={{
          padding: "10px",
          width: "80%",
          marginBottom: "15px",
          border: "1px solid #ccc",
          borderRadius: "4px",
        }}
      />
      <br />
      <button type="submit" className="btn btn-dark">
        Subscribe
      </button>
    </form>
  </div>
</ModalBody>

      ) : (
        <ModalBody
          className="p-0"
          style={{
            width: "600px",
            height: "300px",
            overflow: "hidden",
            padding: 0,
          }}
        >
          <div style={{ display: "flex", height: "100%" }}>
            {form?.image && (
              <div style={{ flex: "1 1 50%", height: "100%" }}>
                <img
                  src={ImageLink(form.image)}
                  alt="Preview"
                  style={{
                    height: "100%",
                    width: "100%",
                    objectFit: "cover",
                    objectPosition: "center",
                    display: "block",
                  }}
                />
              </div>
            )}
            <div
              style={{
                flex: "1 1 50%",
                padding: "20px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                backgroundColor: "#f8f9fa",
              }}
            >
              <h2 style={getStyle(form?.headingStyle)}>{form?.heading}</h2>
              <p className="mt-3">{form?.description}</p>
              {form?.link && (
                <Link
                  to={`https://superbazaar.in${form.link}`}
                  className="btn btn-outline-dark"
                >
                  Shop Now
                </Link>
              )}
            </div>
          </div>
        </ModalBody>
      )}
    </Modal>
  );
};

export default Preview;
